import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label, LabelList } from 'recharts';
import { BarChart, Bar, Cell, ResponsiveContainer, Brush, ReferenceLine } from 'recharts';
const BarChartComponentForQuestions = ({data, showNames}) => {
  if(!data || !data.userQuestionSet) return <h1>No data</h1>
  const average = data.userQuestionSet.reduce((acc, curr) => acc + curr.totalScore, 0) / data.userQuestionSet.length
  const lables = showNames? "fullname" : "username"  
  return (
    <div className='mt-10 border-t border-gray-300 pt-10'>
    <h2 className='text-3xl font-bold'>{data.title}</h2>
    <h3>{data.group_model.name}</h3>
    <h4>ממוצע {average.toFixed(1)}</h4>
    <div style={{ width: "100%", height: 300 }}>
    <ResponsiveContainer width="100%" height="100%">
    <BarChart
  
      data={data.userQuestionSet}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
        
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis interval={0}  style={{fontSize:"13px"}} dataKey={lables} height={90}    angle={-45}  tick={{ textAnchor: "start", fill:"#fff" }} >
          <Label value=""  offset={0} position="insideBottom" />
        </XAxis>
        <YAxis tick={{ dx: -20 }} style={{fontSize:"13px"}} />

    
<Tooltip 
  wrapperStyle={{ color: "black", backgroundColor: "white", border: "1px solid #ccc" }}
/>

      <Legend verticalAlign="top" wrapperStyle={{ lineHeight: '40px', marginTop:"-20px" }} />

      <ReferenceLine y={0} stroke="#000" />

      {/* <Brush dataKey="username" height={30} stroke="#8884d8" /> */}
      <Bar dataKey="totalScore" fill="#82ca9d" >
        <LabelList dataKey="totalScore" position="top" color='black' fill="white" fontSize={10} />
      </Bar>
      <ReferenceLine y={average} stroke="red" strokeWidth={2} strokeDasharray="5 5"  />

    </BarChart>
  </ResponsiveContainer>
  </div>
  </div>
  )
}

export default BarChartComponentForQuestions